export const ContentContainerVariant = {
  Full: 'full',
  Focused: 'focused',
  Split: 'split',
  PrimarySecondary: 'primarySecondary',
  FixedNarrow: 'fixedNarrow',
  FocusedCentered: 'focusedCentered',
} as const;

export type ContentContainerVariantType =
  (typeof ContentContainerVariant)[keyof typeof ContentContainerVariant];

export type ContentContainerProps = {
  /** Layout variant. Defaults to `Full` when omitted. */
  variant?: ContentContainerVariantType;
  contentClass?: string;
  testId?: string;
};
